import { useHeaderScroll as e } from "./useHeaderScroll.js";
import { createContext as t, useContext as n } from "react";
import r from "clsx";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/Header/base/HeaderRoot.tsx
var o = t(!0), s = () => n(o);
function c({ banner: t, mobileBanner: n, pinned: s = !1, desktop: c, mobile: l, children: u, after: d }) {
	let { isVisible: f, headerRef: p } = e();
	return /* @__PURE__ */ i(o.Provider, {
		value: f,
		children: /* @__PURE__ */ a("header", {
			className: r("z-22 w-full max-w-screen", !s && "sticky top-0", f || s ? "pointer-events-auto" : "pointer-events-none"),
			children: [
				t,
				/* @__PURE__ */ a("div", {
					ref: p,
					className: r("relative z-20 m-auto bg-white duration-150 ease-in-out print:hidden", !s && (f ? "translate-y-0" : "-translate-y-full"), "before-white"),
					children: [!s && n ? /* @__PURE__ */ i("div", {
						className: "block sm:hidden",
						children: n
					}) : null, /* @__PURE__ */ a("div", {
						className: "max-w-page m-auto",
						children: [/* @__PURE__ */ a("div", {
							className: "p-x-header",
							children: [/* @__PURE__ */ i("div", {
								className: "desktop-header-display pt-3 pb-2",
								children: c
							}), /* @__PURE__ */ i("div", {
								className: "mobile-header-display sm-md:py-3",
								children: l
							})]
						}), u]
					})]
				}),
				d
			]
		})
	});
}
//#endregion
export { c as HeaderRoot, s as useHeaderVisible };
